<template>
  <div>
    <h1>合作車隊</h1>
    <div class="btnGroup">
      <Button :to="{name: 'EditCooperationTeam'}" type="primary">
        <Icon type="md-add" />新增車隊
      </Button>
    </div>
    <Table stripe border :columns="columns" :no-data-text="noDataText" :data="cooperationTeams">
    </Table>
  </div>
</template>
<script>
import API from "../asset/js/API"

export default {
  created () {
    this.getCooperationtTeamList()
  },
  data () {
    return {
      cooperationTeams:[],
      columns: [
        {
          title: '合作車隊名稱',
          key: 'name'
        },
        {
          title: '客服電話',
          key: 'servicePhone',
        },
        {
          title: '客訴電話',
          key: 'phone'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '車隊權限是否已開啟',
          key: 'isTeamAuth'
        },
        {
          title: "動作",
          slot: "action",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      this.teamId = params.row.teamId
                      this.removeCooperationTeam()
                    }
                  }
                },
                "移除"
              )
            ]);
          }
        }
      ],
      noDataText: '暫無資料',
      totalPage: 1,
      teamId: null
    }
  },
  methods: {
    getCooperationtTeamList(){
      API.get(`/taxicooperation/list`)
      .then(res => {
        this.cooperationTeams = res.result.list
      })
      .catch(err => {
        console.error('取得列表',err)
      })
    },
    removeCooperationTeam(){
      API.delete(`/taxicooperation?teamId=${this.teamId}`)
      .then(res => {
        if(!res.success) throw new RangeError(res.result)
        this.success(res.result)
        this.getCooperationtTeamList()
      })
      .catch(err => {
        this.failure(err.message)
      })
    },
    success(message){
      this.$Message.success({
        content: message,
        duration: 3,
        closable: true
      });
    },
    failure(message) {
      this.$Message.error({
        content: message,
        duration: 3,
        closable: true
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CooperationTeam.vue